import { isSameDomainGameLaunchPath } from './game-play-path';

/**
 * Anchor / window.open target for game launch.
 * Mobile always uses the same tab. Desktop uses the same tab only when the URL is the lobby-mounted
 * launcher (`/game-play/...` or `/game-window-play/...`) so redirect + storage behavior matches mobile web; the legacy launcher
 * host stays a new tab. (Wrapper-specific behavior is decided by the callers, not here.)
 */
export const getGameLaunchNavigationTarget = (
    launcherUrl: string | undefined,
    isMobileDevice: boolean
): '_self' | '_blank' => {
    if (isMobileDevice) {
        return '_self';
    }
    if (!launcherUrl) {
        return '_blank';
    }
    try {
        // Harness launcher URLs are intentionally relative. Supplying an inert
        // base lets us inspect their pathname without changing absolute URLs.
        const { pathname } = new URL(launcherUrl, 'https://same-origin.invalid');
        if (isSameDomainGameLaunchPath(pathname)) {
            return '_self';
        }
    } catch {
        // Not a valid URL; fall through to the default new-tab target.
    }
    return '_blank';
};
